import Title from '../../components/Title';

import Refund from "../../components/Refund";

const RefundPage = () => {
    return (<>
        <Title title={'Ergo Raffle - Refund'}/>
        <main>
            <Refund/>
        </main>
    </>)
}

export default RefundPage;
